module.exports = __webpack_public_path__ + "media/assets/HWE_conference_experience-de6ddc3cc85577e85aba454a02f62349.jpg";